import Vue from 'vue'
import Vuex from 'vuex'
import configuration from '@/models/configuration.js'


Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {    
    currentConfiguration: new configuration()
  },
  getters:{
    currentConfiguration: state => {return state.currentConfiguration}
  },
  mutations: {
    setConfiguration (state, payload) {state.currentConfiguration = payload},
  },
  actions: {
    //addNewStateP3: ({commit},payload)=>{commit('addNewStateP3', payload)},
    //modifyStateP3: ({commit},payload)=>{commit('modifyStateP3', payload)}
  }
})
